import CategoryPage from "@/components/CategoryPage";
import { CATEGORY_PAGES } from "@/data/categories";

export default function PipesRO() {
  return <CategoryPage page={CATEGORY_PAGES.pipesRo} testId="pipes-ro-page" />;
}
